const CommandPaletteHook = {
  mounted() {
    this.container = this.el;
    this.backdrop = this.el.querySelector("[data-command-backdrop]");
    this.input = this.el.querySelector("[data-command-input]");
    this.list = this.el.querySelector("[data-command-list]");
    this.items = Array.from(this.el.querySelectorAll("[data-command]"));
    this.selectedIndex = 0;

    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleGlobalShortcuts = this.handleGlobalShortcuts.bind(this);

    document.addEventListener("keydown", this.handleGlobalShortcuts);
    document.addEventListener("keydown", this.handleKeydown);

    this.items.forEach((item, index) => {
      item.addEventListener("click", () => this.navigate(item));
      if (index === 0) item.classList.add("bg-isx-gray/60");
    });

    if (this.backdrop) {
      this.backdrop.addEventListener("click", () => this.close());
    }

    if (this.input) {
      this.input.addEventListener("input", () => this.filterCommands());
    }
  },

  destroyed() {
    document.removeEventListener("keydown", this.handleGlobalShortcuts);
    document.removeEventListener("keydown", this.handleKeydown);
  },

  handleGlobalShortcuts(event) {
    const isMac = navigator.platform.toUpperCase().includes("MAC");
    const metaPressed = isMac ? event.metaKey : event.ctrlKey;

    if (metaPressed && event.key.toLowerCase() === "k") {
      event.preventDefault();
      this.toggle();
      return;
    }

    if (this.isTyping()) return;

    if (event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      const key = event.key.toLowerCase();
      const match = this.items.find((item) =>
        (item.dataset.shortcut || "").toLowerCase() === `alt+${key}`
      );

      if (match) {
        event.preventDefault();
        this.navigate(match);
      }
    }
  },

  handleKeydown(event) {
    if (this.container.classList.contains("hidden")) return;

    if (event.key === "Escape") {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key === "ArrowDown") {
      event.preventDefault();
      this.moveSelection(1);
      return;
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      this.moveSelection(-1);
      return;
    }

    if (event.key === "Enter") {
      event.preventDefault();
      const visibleItems = this.visibleItems();
      const selectedItem = visibleItems[this.selectedIndex] || visibleItems[0];
      if (selectedItem) this.navigate(selectedItem);
    }
  },

  toggle() {
    if (this.container.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  },

  open() {
    this.container.classList.remove("hidden");
    this.selectedIndex = 0;
    this.filterCommands();
    if (this.input) {
      this.input.value = "";
      this.input.focus();
    }
  },

  close() {
    this.container.classList.add("hidden");
    if (this.input) this.input.blur();
  },

  filterCommands() {
    const query = (this.input?.value || "").toLowerCase().trim();
    this.items.forEach((item) => {
      const label = (item.dataset.label || "").toLowerCase();
      const matches = query === "" || label.includes(query);
      item.classList.toggle("hidden", !matches);
    });

    this.selectedIndex = 0;
    this.updateSelection();
  },

  moveSelection(direction) {
    const visibleItems = this.visibleItems();
    if (visibleItems.length === 0) return;

    this.selectedIndex =
      (this.selectedIndex + direction + visibleItems.length) % visibleItems.length;

    this.updateSelection();
  },

  updateSelection() {
    const visibleItems = this.visibleItems();
    visibleItems.forEach((item, index) => {
      item.classList.toggle("bg-isx-gray/60", index === this.selectedIndex);
    });
  },

  visibleItems() {
    return this.items.filter((item) => !item.classList.contains("hidden"));
  },

  navigate(item) {
    const path = item.dataset.path;
    if (!path) return;
    window.location.href = path;
  },

  isTyping() {
    const active = document.activeElement;
    if (!active) return false;
    const tag = active.tagName.toLowerCase();
    return tag === "input" || tag === "textarea" || active.isContentEditable;
  }
};

export default CommandPaletteHook;
